import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../i18n/LangContext";

export default function AboutCard() {
  const { t } = useLang();
  const [showText, setShowText] = useState(false);

  const texto = (
    <div className="text-sm sm:text-base">
      <p className="text-slate-600 dark:text-slate-300 mb-3">
        {t("card.intro")}
      </p>
      <p className="text-slate-600 dark:text-slate-300">
        {t("card.bye")}
      </p>
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative rounded-2xl p-5 sm:p-8 bg-slate-50 dark:bg-slate-900 shadow-md flex flex-col sm:flex-row items-center gap-6 z-10"
    >
      {/* Texto escritorio */}
      <div className="hidden sm:flex flex-1 flex-col">
        <h2 className="text-3xl font-bold mb-4">{t("card.greeting")}</h2>
        {texto}
      </div>

      {/* Foto + overlay móvil */}
      <div
        className="flex-shrink-0 relative w-full sm:w-auto flex justify-between cursor-pointer"
        onClick={() => setShowText(!showText)}
      >
        {/* Título solo en móvil */}
        <h2
          className={`block sm:hidden text-xl mr-5 font-bold mb-2 transition-opacity duration-700 ${
            showText ? "opacity-0" : "opacity-100"
          }`}
        >
          {t("card.greetingMobile.0")}<br />{t("card.greetingMobile.1")}
        </h2>

        <motion.img
          src="/me.png"
          alt="Jaime Gimillo"
          className={`block sm:hidden w-36 h-36 rounded-full shadow-lg  transition-opacity duration-700 ${
            showText ? "opacity-15" : "opacity-100"
          }`}
          whileTap={{ scale: 0.97 }}
        />

        <motion.img
          src="/me.png"
          alt="Jaime Gimillo"
          className="hidden sm:block w-56 h-56 rounded-full shadow-lg"
          whileTap={{ scale: 0.97 }}
        />

        {/* Overlay tarjeta móvil */}
        <AnimatePresence>
          {showText && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.7 }}
              className="absolute inset-0 p-6 flex flex-col justify-center items-center rounded-2xl sm:hidden text-center"
            >
              {texto}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
